module.exports = __webpack_public_path__ + "img/1f3db.93a63bf.svg";